// Generated by tools/generate-replay-classes.cjs. Do not add runtime values.
export const REPLAY_STATIC_CLASSES = new Set([
  'absolute',
  'an-ask-navi-go',
  'an-ask-navi-go__icon',
  'an-ask-navi-go__input',
  'an-ask-navi-go__row',
  'ask-navi-layout',
  'ask-navi-layout__main',
  'assistant',
  'avatar',
  'avatar-wiggle',
  'badges',
  'bds-card-header-image',
  'bds-card-row',
  'bds-list-stack',
  'bds-scroll-region--both',
  'bds-scroll-region--horizontal',
  'bds-scroll-region--max-height',
  'bds-scroll-region__content',
  'bds-scroll-region__horizontal-thumb',
  'bds-scroll-region__horizontal-thumb--dragging',
  'bds-scroll-region__horizontal-track',
  'bds-scroll-region__thumb',
  'bds-scroll-region__track',
  'bds-scroll-region__track--active',
  'bds-scroll-region__track--dragging',
  'bds-scroll-region__viewport',
  'bg-gray-50',
  'bg-primary',
  'bg-primary-50',
  'bg-primary-600',
  'bg-surface-0',
  'bg-surface-100',
  'bg-surface-50',
  'bg-transparent',
  'bg-white',
  'block',
  'bn-account-detail-dialog',
  'bn-account-detail__body',
  'bn-account-detail__compact',
  'bn-account-detail__compact-item',
  'bn-account-detail__compact-label',
  'bn-account-detail__compact-value',
  'bn-account-detail__error',
  'bn-account-detail__heading',
  'bn-account-detail__ledger',
  'bn-account-detail__skeleton',
  'bn-account-detail__stack',
  'bn-account-detail__subline',
  'bn-account-detail__summary',
  'bn-account-detail__title',
  'bn-account-detail__title-row',
  'bn-account-metrics',
  'bn-account-metrics__item',
  'bn-account-metrics__label',
  'bn-account-metrics__value',
  'bn-account-txns',
  'bn-account-txns__amount',
  'bn-account-txns__amount--in',
  'bn-account-txns__amount-h',
  'bn-account-txns__count',
  'bn-account-txns__date',
  'bn-account-txns__date-cell',
  'bn-account-txns__desc',
  'bn-account-txns__empty',
  'bn-account-txns__error',
  'bn-account-txns__field',
  'bn-account-txns__field--date',
  'bn-account-txns__field--range',
  'bn-account-txns__field--search',
  'bn-account-txns__field--status',
  'bn-account-txns__footer',
  'bn-account-txns__invalid',
  'bn-account-txns__label',
  'bn-account-txns__more-error',
  'bn-account-txns__page-btn',
  'bn-account-txns__pager',
  'bn-account-txns__search',
  'bn-account-txns__select',
  'bn-account-txns__skeleton',
  'bn-account-txns__table',
  'bn-account-txns__toolbar',
  'bn-account-txns__truncated',
  'bn-account-txns__unavailable',
  'bn-accounts',
  'bn-accounts-banner',
  'bn-accounts-banner__body',
  'bn-accounts-banner__headline',
  'bn-accounts-banner__icon',
  'bn-accounts-count',
  'bn-accounts-group',
  'bn-accounts-group__count',
  'bn-accounts-group__label',
  'bn-accounts-row__balance',
  'bn-accounts-row__details',
  'bn-accounts-row__last4',
  'bn-accounts-row__name',
  'bn-accounts-skeleton',
  'bn-accounts-skeleton__end',
  'bn-accounts-skeleton__header',
  'bn-accounts-skeleton__name',
  'bn-accounts-skeleton__row',
  'bn-accounts-status',
  'bn-accounts-tab',
  'bn-accounts-table',
  'bn-accounts-table--grouped',
  'bn-accounts-table__details',
  'bn-accounts-table__details-label',
  'bn-accounts-toolbar',
  'bn-accounts-toolbar__field',
  'bn-accounts-toolbar__field--compact',
  'bn-accounts-toolbar__field--search',
  'bn-accounts-toolbar__field--status',
  'bn-accounts-toolbar__label',
  'bn-accounts-toolbar__meta',
  'bn-accounts-toolbar__reset',
  'bn-accounts-toolbar__select',
  'bn-accounts__empty',
  'bn-accounts__error',
  'bn-accounts__search',
  'bn-action',
  'bn-action-card--closed',
  'bn-action-card__actions',
  'bn-action-card__actions--client-view',
  'bn-action-card__chips',
  'bn-action-card__description',
  'bn-action-card__domain',
  'bn-action-card__edit',
  'bn-action-card__links',
  'bn-action-card__meta',
  'bn-action-card__overdue',
  'bn-action-card__promise',
  'bn-action-card__status',
  'bn-action-card__title',
  'bn-action-editor-dialog-host',
  'bn-action-editor__assignee',
  'bn-action-editor__assignee-panel',
  'bn-action-editor__cancel',
  'bn-action-editor__date',
  'bn-action-editor__description-control',
  'bn-action-editor__error',
  'bn-action-editor__footer-content',
  'bn-action-editor__label',
  'bn-action-editor__meta-error',
  'bn-action-editor__meta-label',
  'bn-action-editor__metadata-content',
  'bn-action-editor__owner',
  'bn-action-editor__owner-hint',
  'bn-action-editor__owner-option',
  'bn-action-editor__promise',
  'bn-action-editor__save-error',
  'bn-action-editor__select',
  'bn-action-editor__status-value',
  'bn-action-editor__timestamps',
  'bn-action-editor__title-control',
  'bn-action-editor__title-field',
  'bn-action__disposition',
  'bn-action__fold-label',
  'bn-action__fold-toggle',
  'bn-action__head',
  'bn-action__index',
  'bn-action__instruction',
  'bn-action__rationale',
  'bn-action__title',
  'bn-action__type',
  'bn-actions-section',
  'bn-actions-section__add',
  'bn-actions-section__dependency',
  'bn-actions-section__header',
  'bn-actions-section__message',
  'bn-actions-section__title',
  'bn-admin-scroll-region',
  'bn-both-collapsed-fill',
  'bn-care-plan-card-list',
  'bn-care-plan-editor-row',
  'bn-care-plan-editor-row__control',
  'bn-care-plan-editor-row__error',
  'bn-care-plan-editor-row__icon',
  'bn-care-plan-editor-row__label',
  'bn-care-plan-editor-shell',
  'bn-care-plan-editor-shell__footer',
  'bn-care-plan-editor-shell__heading',
  'bn-care-plan-editor-shell__metadata',
  'bn-care-plan-item-card',
  'bn-care-plan-item-card__actions',
  'bn-care-plan-item-card__main',
  'bn-care-plan-panel',
  'bn-care-plan-panel__actions',
  'bn-care-plan-panel__error',
  'bn-care-plan-panel__error-link',
  'bn-care-plan-panel__header',
  'bn-care-plan-panel__menu-toggle',
  'bn-care-plan-panel__open-case',
  'bn-care-plan-panel__skeleton',
  'bn-care-plan-panel__title',
  'bn-care-plan-status-overlay',
  'bn-care-plan-status-select',
  'bn-care-plan-tab',
  'bn-case-card',
  'bn-case-card--expanded',
  'bn-case-card__chevron',
  'bn-case-card__created',
  'bn-case-card__heading',
  'bn-case-card__panel',
  'bn-case-card__row',
  'bn-case-card__title',
  'bn-case-detail',
  'bn-case-detail__closed-banner',
  'bn-case-detail__description',
  'bn-case-detail__description-input',
  'bn-case-detail__headline',
  'bn-case-detail__plan-grid',
  'bn-case-detail__reopen',
  'bn-case-detail__status',
  'bn-case-detail__status-menu',
  'bn-case-detail__status-option',
  'bn-case-detail__status-option--close',
  'bn-case-detail__status-pill',
  'bn-case-detail__tab',
  'bn-case-detail__tab--active',
  'bn-case-detail__tab--disabled',
  'bn-case-detail__tabs',
  'bn-case-goal-links',
  'bn-case-goal-links__label',
  'bn-case-goal-links__pill',
  'bn-case-goal-links__select',
  'bn-case-goal-links__unlink',
  'bn-case-group',
  'bn-case-group__chevron',
  'bn-case-group__dot',
  'bn-case-group__header',
  'bn-case-group__label',
  'bn-case-group__list',
  'bn-case-group__meta',
  'bn-case-list',
  'bn-case-list__cases',
  'bn-case-list__chips',
  'bn-case-list__filter',
  'bn-case-list__filter-miss',
  'bn-case-list__filters',
  'bn-case-list__group-by',
  'bn-case-list__group-by-label',
  'bn-case-list__reset',
  'bn-case-list__toggle',
  'bn-case-list__toggle--active',
  'bn-case-list__toggles',
  'bn-case-list__toolbar',
  'bn-case-status-badge',
  'bn-chat-pane-header',
  'bn-chat-pane-header__actions',
  'bn-chat-pane-header__title',
  'bn-close-case-dialog',
  'bn-close-case-dialog__cancel',
  'bn-close-case-dialog__error',
  'bn-close-case-dialog__header',
  'bn-close-case-dialog__label',
  'bn-close-case-dialog__reason',
  'bn-close-case-dialog__reason--selected',
  'bn-close-case-dialog__title',
  'bn-content-collapsed-strip',
  'bn-content-pane-header',
  'bn-content-pane-header__title',
  'bn-content-splitter',
  'bn-content-strip-icon',
  'bn-content-strip-label',
  'bn-copilot-collapsed-strip',
  'bn-copilot-strip-btn',
  'bn-copilot-strip-icon',
  'bn-credit-badge',
  'bn-credit-report',
  'bn-credit-report__body',
  'bn-credit-report__error',
  'bn-credit-report__header',
  'bn-credit-report__heading',
  'bn-credit-report__highlight',
  'bn-credit-report__highlight--active',
  'bn-credit-report__highlights',
  'bn-credit-report__loading',
  'bn-credit-report__page',
  'bn-credit-report__page--match',
  'bn-credit-report__pages',
  'bn-credit-report__search',
  'bn-credit-report__search-field',
  'bn-credit-report__search-status',
  'bn-credit__chart',
  'bn-credit__chart-dates',
  'bn-credit__chart-labels',
  'bn-credit__chart-plot',
  'bn-credit__data-warning',
  'bn-credit__debt-bar',
  'bn-credit__debt-breakdown',
  'bn-credit__debt-legend',
  'bn-credit__debt-segment',
  'bn-credit__debt-summary',
  'bn-credit__debt-swatch',
  'bn-credit__empty',
  'bn-credit__error',
  'bn-credit__eyebrow',
  'bn-credit__failure-action',
  'bn-credit__header-loading',
  'bn-credit__loading',
  'bn-credit__momentum',
  'bn-credit__muted',
  'bn-credit__no-score-card',
  'bn-credit__no-score-copy',
  'bn-credit__no-score-icon',
  'bn-credit__pagination',
  'bn-credit__report-action',
  'bn-credit__row-warning',
  'bn-credit__score',
  'bn-credit__score-card',
  'bn-credit__score-header',
  'bn-credit__score-range',
  'bn-credit__sort-header',
  'bn-credit__table',
  'bn-credit__timeline',
  'bn-credit__timeline-header',
  'bn-credit__timeline-marker',
  'bn-credit__timeline-panel',
  'bn-credit__timeline-status',
  'bn-credit__timeline-step',
  'bn-credit__timeline-subtext',
  'bn-credit__timeline-title',
  'bn-credit__timeline-title-row',
  'bn-cs',
  'bn-cs__body',
  'bn-cs__collapse',
  'bn-cs__header',
  'bn-cs__icon',
  'bn-cs__title',
  'bn-cs__title-row',
  'bn-dashboard',
  'bn-dashboard__date',
  'bn-dashboard__empty',
  'bn-dashboard__greeting',
  'bn-dashboard__header',
  'bn-dashboard__widget',
  'bn-dashboard__widget--card',
  'bn-dashboard__widgets',
  'bn-debug',
  'bn-debug__copy',
  'bn-debug__empty',
  'bn-debug__panel',
  'bn-debug__row',
  'bn-debug__rows',
  'bn-debug__toggle',
  'bn-debug__value',
  'bn-detail',
  'bn-detail-dialog',
  'bn-detail__body',
  'bn-detail__buttons',
  'bn-detail__buttons-end',
  'bn-detail__client',
  'bn-detail__client--unknown',
  'bn-detail__close',
  'bn-detail__description',
  'bn-detail__field-hint',
  'bn-detail__field-label',
  'bn-detail__footer',
  'bn-detail__header',
  'bn-detail__header-top',
  'bn-detail__no-actions',
  'bn-detail__note',
  'bn-detail__proposed',
  'bn-detail__section-count',
  'bn-detail__section-label',
  'bn-detail__section-note',
  'bn-detail__settled',
  'bn-detail__title',
  'bn-filter-overlay',
  'bn-filter-select',
  'bn-filters',
  'bn-filters__field',
  'bn-filters__field--action',
  'bn-filters__field--group',
  'bn-filters__label',
  'bn-filters__primary',
  'bn-filters__reset',
  'bn-finances-tab',
  'bn-fs-badge',
  'bn-fs-card__actions',
  'bn-fs-card__empty',
  'bn-fs-card__empty-msg',
  'bn-fs-card__error',
  'bn-fs-card__grid',
  'bn-fs-card__grid-container',
  'bn-fs-card__header-loading',
  'bn-fs-card__muted',
  'bn-fs-edit',
  'bn-fs-edit-dialog',
  'bn-fs-edit__add-custom',
  'bn-fs-edit__cat',
  'bn-fs-edit__cat--error',
  'bn-fs-edit__cat-header',
  'bn-fs-edit__cat-row',
  'bn-fs-edit__close',
  'bn-fs-edit__col',
  'bn-fs-edit__col-title',
  'bn-fs-edit__custom',
  'bn-fs-edit__custom-head',
  'bn-fs-edit__custom-remove',
  'bn-fs-edit__custom-title',
  'bn-fs-edit__error',
  'bn-fs-edit__field',
  'bn-fs-edit__field--row',
  'bn-fs-edit__field--stack',
  'bn-fs-edit__field-end',
  'bn-fs-edit__footer',
  'bn-fs-edit__grid',
  'bn-fs-edit__header',
  'bn-fs-edit__hint',
  'bn-fs-edit__input',
  'bn-fs-edit__label-input',
  'bn-fs-edit__pct',
  'bn-fs-edit__preview',
  'bn-fs-edit__preview-row',
  'bn-fs-edit__preview-row--shortfall',
  'bn-fs-edit__progress',
  'bn-fs-edit__row-label',
  'bn-fs-edit__savings',
  'bn-fs-edit__subs',
  'bn-fs-edit__sum-badge',
  'bn-fs-edit__sum-box',
  'bn-fs-edit__sum-wrap',
  'bn-fs-edit__tip',
  'bn-fs-edit__title',
  'bn-fs-edit__total-note',
  'bn-fs-edit__total-row',
  'bn-fs-mix',
  'bn-fs-mix__bar-fill',
  'bn-fs-mix__bar-track',
  'bn-fs-mix__chev',
  'bn-fs-mix__heading',
  'bn-fs-mix__heading-meta',
  'bn-fs-mix__heading-row',
  'bn-fs-mix__item',
  'bn-fs-mix__label',
  'bn-fs-mix__label--btn',
  'bn-fs-mix__list',
  'bn-fs-mix__meta',
  'bn-fs-mix__pct',
  'bn-fs-mix__sub',
  'bn-fs-mix__subs',
  'bn-fs-mix__values',
  'bn-fs-progress',
  'bn-fs-progress__actions',
  'bn-fs-progress__amount',
  'bn-fs-progress__bar',
  'bn-fs-progress__bar-wrap',
  'bn-fs-progress__item',
  'bn-fs-progress__item--done',
  'bn-fs-progress__label',
  'bn-fs-progress__list',
  'bn-fs-progress__pending',
  'bn-fs-progress__source',
  'bn-fs-progress__toolbar',
  'bn-fs-progress__value',
  'bn-fs-skeleton',
  'bn-fs-skeleton__actions',
  'bn-fs-skeleton__col',
  'bn-fs-skeleton__grid',
  'bn-fs-skeleton__mix-head',
  'bn-fs-skeleton__mix-row',
  'bn-fs-summary',
  'bn-fs-summary__actions',
  'bn-fs-summary__bar-block',
  'bn-fs-summary__bar-fill',
  'bn-fs-summary__bar-label',
  'bn-fs-summary__bar-track',
  'bn-fs-summary__chev',
  'bn-fs-summary__heading',
  'bn-fs-summary__income-btn',
  'bn-fs-summary__metrics',
  'bn-fs-summary__net',
  'bn-fs-summary__net--shortfall',
  'bn-fs-summary__net--surplus',
  'bn-fs-summary__net-helper',
  'bn-fs-summary__net-label',
  'bn-fs-summary__net-value',
  'bn-fs-summary__row',
  'bn-fs-summary__sub',
  'bn-fs-summary__subs',
  'bn-fs-summary__top',
  'bn-goals-bar',
  'bn-goals-bar__empty',
  'bn-goals-bar__label',
  'bn-goals-bar__manage',
  'bn-goals-bar__pill',
  'bn-goals-bar__pill-count',
  'bn-goals-bar__pills',
  'bn-group',
  'bn-hm-profile-body',
  'bn-hm-profile-close',
  'bn-hm-profile-header',
  'bn-hm-profile-subtitle',
  'bn-hm-profile-title',
  'bn-household-body',
  'bn-household-close',
  'bn-household-dob',
  'bn-household-guid',
  'bn-household-guid-copy',
  'bn-household-guid-value',
  'bn-household-header',
  'bn-household-list',
  'bn-household-member-profile-dialog',
  'bn-household-name',
  'bn-household-relationship',
  'bn-household-row',
  'bn-household-row-active',
  'bn-household-row-clickable',
  'bn-household-subtitle',
  'bn-household-title',
  'bn-linked',
  'bn-linked__empty',
  'bn-linked__item',
  'bn-linked__label',
  'bn-linked__last4',
  'bn-linked__list',
  'bn-linked__name',
  'bn-list',
  'bn-manage-case-goals-dialog',
  'bn-manage-case-goals-dialog__action',
  'bn-manage-case-goals-dialog__add',
  'bn-manage-case-goals-dialog__cancel',
  'bn-manage-case-goals-dialog__cap',
  'bn-manage-case-goals-dialog__draft',
  'bn-manage-case-goals-dialog__goals',
  'bn-manage-case-goals-dialog__header',
  'bn-manage-case-goals-dialog__label',
  'bn-manage-case-goals-dialog__title',
  'bn-manage-goals-dialog',
  'bn-manage-goals-dialog__action',
  'bn-manage-goals-dialog__action--complete',
  'bn-manage-goals-dialog__action--remove',
  'bn-manage-goals-dialog__add',
  'bn-manage-goals-dialog__badge',
  'bn-manage-goals-dialog__cap',
  'bn-manage-goals-dialog__count',
  'bn-manage-goals-dialog__draft',
  'bn-manage-goals-dialog__editor',
  'bn-manage-goals-dialog__handle',
  'bn-manage-goals-dialog__header',
  'bn-manage-goals-dialog__list',
  'bn-manage-goals-dialog__row',
  'bn-manage-goals-dialog__row--dragging',
  'bn-manage-goals-dialog__row--marked',
  'bn-manage-goals-dialog__text',
  'bn-manage-goals-dialog__title',
  'bn-metadata-avatar',
  'bn-metadata-badge',
  'bn-metadata-badge--dnc',
  'bn-metadata-badge--eligible',
  'bn-metadata-badge--not-eligible',
  'bn-metadata-badge--vip',
  'bn-metadata-badge-dot',
  'bn-metadata-company',
  'bn-metadata-copy-btn',
  'bn-metadata-details',
  'bn-metadata-field',
  'bn-metadata-field--wide',
  'bn-metadata-footer-refresh',
  'bn-metadata-grid',
  'bn-metadata-guid',
  'bn-metadata-guid-left',
  'bn-metadata-guid-value',
  'bn-metadata-icon-btn',
  'bn-metadata-label',
  'bn-metadata-link',
  'bn-metadata-name',
  'bn-metadata-primary',
  'bn-metadata-skeleton',
  'bn-metadata-value',
  'bn-notes',
  'bn-notes__actor',
  'bn-notes__meta',
  'bn-notes__text',
  'bn-open-actions',
  'bn-open-actions__bar',
  'bn-open-actions__bar--overdue',
  'bn-open-actions__bar--today',
  'bn-open-actions__bar-count',
  'bn-open-actions__bar-label',
  'bn-open-actions__bar-plot',
  'bn-open-actions__bar-seg',
  'bn-open-actions__bar-seg--high',
  'bn-open-actions__bar-seg--normal',
  'bn-open-actions__bar-stack',
  'bn-open-actions__bar-sublabel',
  'bn-open-actions__cards',
  'bn-open-actions__chart',
  'bn-open-actions__chart-head',
  'bn-open-actions__chart-title',
  'bn-open-actions__chart-title-row',
  'bn-open-actions__chip',
  'bn-open-actions__chip--blocked',
  'bn-open-actions__chip--high',
  'bn-open-actions__chip--promise',
  'bn-open-actions__chips',
  'bn-open-actions__count',
  'bn-open-actions__details',
  'bn-open-actions__filter',
  'bn-open-actions__filter-chip',
  'bn-open-actions__filter-chip--active',
  'bn-open-actions__filter-chip--empty',
  'bn-open-actions__filter-chip--later',
  'bn-open-actions__filter-chip--nextWeek',
  'bn-open-actions__filter-chip--overdue',
  'bn-open-actions__filter-chip--today',
  'bn-open-actions__filter-chip--week',
  'bn-open-actions__filter-chip-count',
  'bn-open-actions__filters',
  'bn-open-actions__header',
  'bn-open-actions__heading',
  'bn-open-actions__legend',
  'bn-open-actions__legend-item',
  'bn-open-actions__legend-swatch',
  'bn-open-actions__legend-swatch--high',
  'bn-open-actions__legend-swatch--normal',
  'bn-open-actions__link',
  'bn-open-actions__loading',
  'bn-open-actions__message',
  'bn-open-actions__pager',
  'bn-open-actions__pager-nav',
  'bn-open-actions__pill',
  'bn-open-actions__pill--later',
  'bn-open-actions__pill--overdue',
  'bn-open-actions__pill--soon',
  'bn-open-actions__reset',
  'bn-open-actions__row',
  'bn-open-actions__search',
  'bn-open-actions__show-all',
  'bn-open-actions__sort',
  'bn-open-actions__status',
  'bn-open-actions__summary',
  'bn-open-actions__table',
  'bn-open-actions__title',
  'bn-open-actions__toggle',
  'bn-open-actions__toggle--active',
  'bn-open-actions__toggles',
  'bn-open-actions__toolbar',
  'bn-open-actions__type',
  'bn-open-case-dialog',
  'bn-open-case-dialog__action',
  'bn-open-case-dialog__add',
  'bn-open-case-dialog__cancel',
  'bn-open-case-dialog__cap',
  'bn-open-case-dialog__classification',
  'bn-open-case-dialog__draft',
  'bn-open-case-dialog__error',
  'bn-open-case-dialog__field',
  'bn-open-case-dialog__goals',
  'bn-open-case-dialog__header',
  'bn-open-case-dialog__label',
  'bn-open-case-dialog__link',
  'bn-open-case-dialog__status',
  'bn-open-case-dialog__title',
  'bn-open-case-dialog__warning',
  'bn-option-card__actions',
  'bn-option-card__description',
  'bn-option-card__edit',
  'bn-option-card__status',
  'bn-option-card__status--abandoned',
  'bn-option-card__status--declined',
  'bn-option-card__status--discussed',
  'bn-option-card__status--identified',
  'bn-option-card__status--qualified',
  'bn-option-card__status--selected',
  'bn-option-card__title',
  'bn-option-card__type',
  'bn-option-editor-dialog-host',
  'bn-option-editor__cancel',
  'bn-option-editor__count',
  'bn-option-editor__description-field',
  'bn-option-editor__error',
  'bn-option-editor__footer-content',
  'bn-option-editor__label',
  'bn-option-editor__meta-error',
  'bn-option-editor__metadata-content',
  'bn-option-editor__override-advisory',
  'bn-option-editor__override-row',
  'bn-option-editor__qualification-warning',
  'bn-option-editor__select',
  'bn-option-editor__sr-only',
  'bn-option-editor__title-control',
  'bn-option-editor__title-field',
  'bn-options-section',
  'bn-options-section__add',
  'bn-options-section__header',
  'bn-options-section__message',
  'bn-options-section__title',
  'bn-outcome-card__actions',
  'bn-outcome-card__ati',
  'bn-outcome-card__chip',
  'bn-outcome-card__description',
  'bn-outcome-card__heading',
  'bn-outcome-card__meta',
  'bn-outcome-card__open',
  'bn-outcome-card__recorded',
  'bn-outcome-card__removed',
  'bn-outcome-card__title',
  'bn-outcome-card__type',
  'bn-outcome-details-overlay',
  'bn-outcome-editor-dialog-host',
  'bn-outcome-editor__amount',
  'bn-outcome-editor__case-info',
  'bn-outcome-editor__case-info-details',
  'bn-outcome-editor__case-info-toggle',
  'bn-outcome-editor__description',
  'bn-outcome-editor__error',
  'bn-outcome-editor__footer',
  'bn-outcome-editor__help',
  'bn-outcome-editor__hint',
  'bn-outcome-editor__metadata',
  'bn-outcome-editor__name-control',
  'bn-outcome-editor__remove',
  'bn-outcome-editor__title',
  'bn-outcomes',
  'bn-outcomes__description',
  'bn-outcomes__details',
  'bn-outcomes__details-trigger',
  'bn-outcomes__edit',
  'bn-outcomes__empty',
  'bn-outcomes__hint',
  'bn-outcomes__impact',
  'bn-outcomes__item',
  'bn-outcomes__item--removed',
  'bn-outcomes__list',
  'bn-outcomes__notice',
  'bn-outcomes__pill',
  'bn-outcomes__record',
  'bn-outcomes__removed',
  'bn-outcomes__retry',
  'bn-outcomes__type-label',
  'bn-pager',
  'bn-pager__controls',
  'bn-pager__page',
  'bn-pager__range',
  'bn-pager__step',
  'bn-review',
  'bn-review-home',
  'bn-review-home__actions',
  'bn-review-home__activity',
  'bn-review-home__chip',
  'bn-review-home__client',
  'bn-review-home__header',
  'bn-review-home__heading',
  'bn-review-home__lede',
  'bn-review-home__link',
  'bn-review-home__meta',
  'bn-review-home__pager',
  'bn-review-home__pill',
  'bn-review-home__quote',
  'bn-review-home__row',
  'bn-review-home__status',
  'bn-review-home__table',
  'bn-review-home__table-wrap',
  'bn-review-home__tight',
  'bn-review-home__title',
  'bn-review-tab',
  'bn-review__caveat',
  'bn-review__empty',
  'bn-review__empty-hint',
  'bn-review__error',
  'bn-review__error-detail',
  'bn-review__error-title',
  'bn-review__summary',
  'bn-review__summary-counts',
  'bn-review__summary-right',
  'bn-review__total',
  'bn-row',
  'bn-row--skeleton',
  'bn-row__action-count',
  'bn-row__actions-list',
  'bn-row__body',
  'bn-row__cta-group',
  'bn-row__heading',
  'bn-row__heading-meta',
  'bn-row__open',
  'bn-row__side',
  'bn-row__time',
  'bn-row__title',
  'bn-row__unseen',
  'bn-search-hit',
  'bn-search-hit-kv',
  'bn-search-hit-kv--after-heading',
  'bn-search-hit__action-hint',
  'bn-search-hit__action-hint--existing',
  'bn-search-hit__action-hint--new',
  'bn-search-hit__action-hint-label',
  'bn-search-hit__heading',
  'bn-search-hit__heading-row',
  'bn-search-hit__trigger',
  'bn-spending-summary',
  'bn-spending-summary__balance',
  'bn-spending-summary__empty',
  'bn-spending-summary__item',
  'bn-spending-summary__label',
  'bn-spending-summary__last4',
  'bn-spending-summary__list',
  'bn-spending-summary__section',
  'bn-stamp-tooltip',
  'bn-status',
  'bn-status__dot',
  'bn-tab-bar-host',
  'bn-tab-bar__count-badge',
  'bn-tab-bar__dropdown',
  'bn-tab-bar__dropdown-check',
  'bn-tab-bar__dropdown-icon',
  'bn-tab-bar__dropdown-item',
  'bn-tab-bar__dropdown-item--active',
  'bn-tab-bar__dropdown-label',
  'bn-tab-bar__dropdown-row',
  'bn-tab-bar__measure',
  'bn-tab-bar__more-btn',
  'bn-tab-bar__more-btn--active',
  'bn-tab-bar__more-btn--has-update',
  'bn-tab-bar__more-icon',
  'bn-tab-bar__more-icon--open',
  'bn-tab-bar__pin-badge',
  'bn-tab-bar__pin-btn',
  'bn-tab-bar__pin-btn--pinned',
  'bn-tab-bar__pin-icon',
  'bn-tab-bar__pin-icon--locked',
  'bn-tab-bar__row',
  'bn-tab-bar__tab',
  'bn-tab-bar__tab--active',
  'bn-tab-bar__tab--temp',
  'bn-tab-bar__tab-icon',
  'bn-tab-bar__update-dot',
  'bn-trigger',
  'bn-trigger__head',
  'bn-trigger__link',
  'bn-trigger__message',
  'bn-trigger__messages',
  'bn-trigger__source',
  'bn-unlinked-outcomes',
  'border',
  'border-0',
  'border-b',
  'border-gray-300',
  'border-primary-100',
  'border-r',
  'border-surface-200',
  'border-surface-300',
  'border-t',
  'border-t-2',
  'break-all',
  'capitalize',
  'cdk-overlay-pane',
  'chat',
  'chat-input',
  'chat-input__actions',
  'chat-input__composer',
  'chat-input__textarea',
  'chat-menubar',
  'chat-messages',
  'chat-messages-before-scroll',
  'chat-messages-scroll',
  'chat-messages-scroll-region',
  'chat-scroll-container',
  'chat-scroll-to-bottom',
  'chat-search-close',
  'chat-search-count',
  'chat-search-floating',
  'chat-search-floating--expanded',
  'chat-search-input',
  'chat-search-mark',
  'chat-search-mark-active',
  'chat-search-nav',
  'chat-search-panel',
  'chat-search-toggle',
  'chat-splitter-host',
  'chat-suggestion-bar',
  'chat-suggestion-bar__bolt',
  'chat-suggestion-bar__chips',
  'chat-suggestion-bar__label',
  'chat-suggestion-bar__title',
  'chat-suggestion-chip',
  'chat-suggestion-view-all',
  'chat-suggestions-popover-body',
  'chat-suggestions-popover-chips',
  'chat-suggestions-popover-panel',
  'chat-suggestions-popover-title',
  'chat-wrapper',
  'chat__error',
  'chip-clear',
  'client-archived',
  'client-company',
  'client-guid',
  'client-highlighted',
  'client-info-actions',
  'client-info-button',
  'client-info-row',
  'client-info-wrapper',
  'client-metadata',
  'client-name',
  'client-profile',
  'client-search-wrapper',
  'client-selected',
  'client-skeleton-wrapper',
  'component',
  'connector-status',
  'connector-status--compact',
  'connector-status__action',
  'connector-status__action--secondary',
  'connector-status__chevron',
  'connector-status__copy',
  'connector-status__details',
  'connector-status__error',
  'connector-status__heading',
  'connector-status__list',
  'connector-status__name',
  'connector-status__refresh',
  'connector-status__row',
  'connector-status__row-error',
  'connector-status__state',
  'connector-status__trigger',
  'content',
  'css',
  'cursor-pointer',
  'dark:bg-surface-800',
  'dark:bg-surface-900',
  'dark:border-surface-700',
  'dark:focus-visible:ring-offset-surface-900',
  'dark:text-surface-0',
  'dark:text-surface-200',
  'dark:text-surface-400',
  'delete-button',
  'disabled',
  'divide-surface-100',
  'divide-y',
  'dot',
  'dots',
  'dropdown-item',
  'duration-200',
  'duration-300',
  'ease-in-out',
  'fade-gradient-overlay',
  'flex',
  'flex-1',
  'flex-col',
  'flex-row',
  'flex-shrink-0',
  'flex-wrap',
  'focus-visible:outline-none',
  'focus-visible:ring-2',
  'focus-visible:ring-[var(--p-primary-color)]',
  'focus-visible:ring-offset-2',
  'focus-visible:ring-primary',
  'focus-visible:ring-white',
  'focused',
  'font-bold',
  'font-medium',
  'font-mono',
  'font-normal',
  'font-semibold',
  'g',
  'gap-1',
  'gap-1.5',
  'gap-2',
  'gap-3',
  'gap-4',
  'gap-5',
  'gap-8',
  'grid',
  'group',
  'group-hover:opacity-100',
  'h-11',
  'h-12',
  'h-5',
  'h-6',
  'h-8',
  'h-[200px]',
  'h-full',
  'h-screen',
  'handle-archived-button',
  'has-actions',
  'hover:bg-primary-700',
  'hover:shadow-md',
  'hover:text-surface-700',
  'inline-flex',
  'italic',
  'items-center',
  'items-start',
  'items-stretch',
  'json',
  'justify-between',
  'justify-center',
  'justify-end',
  'label',
  'leading-normal',
  'leading-tight',
  'lib-feedback-dialog',
  'list-none',
  'loading',
  'log-test',
  'log-test__badge',
  'log-test__coverage',
  'log-test__details',
  'log-test__group-count',
  'log-test__group-heading',
  'log-test__group-title',
  'log-test__id',
  'log-test__outcome',
  'log-test__result',
  'log-test__run',
  'log-test__scenario-heading',
  'log-test__scenario-title',
  'log-test__scenarios',
  'm-0',
  'markdown-body',
  'max-h-full',
  'max-w-3xl',
  'max-w-md',
  'max-w-sm',
  'mb-1',
  'mb-2',
  'mb-3',
  'mb-4',
  'md',
  'message',
  'message__wrapper',
  'meta',
  'min-h-0',
  'min-h-11',
  'min-h-[2.5rem]',
  'min-h-[2rem]',
  'min-h-screen',
  'min-w-0',
  'ml-auto',
  'mr-1',
  'mr-2',
  'mt-1',
  'mt-2',
  'mt-3',
  'mt-4',
  'mt-6',
  'mx-4',
  'ng-dirty',
  'ng-invalid',
  'ng-pristine',
  'ng-untouched',
  'no-results',
  'no-underline',
  'object-cover',
  'omni-dropdown',
  'omni-history-count',
  'omni-history-palette',
  'omni-history-query',
  'omni-history-query-text',
  'omni-history-remove',
  'omni-history-row',
  'omni-palette',
  'omni-palette-with-sticky-header',
  'omni-search-bar',
  'omni-search-container',
  'opacity-0',
  'opacity-50',
  'org',
  'outline-none',
  'overflow-auto',
  'overflow-hidden',
  'overflow-y-auto',
  'p-0',
  'p-2',
  'p-2.5',
  'p-3',
  'p-4',
  'p-6',
  'p-8',
  'p-accordion',
  'p-accordioncontent',
  'p-accordioncontent-content',
  'p-accordionheader',
  'p-accordionheader-toggle-icon',
  'p-accordionpanel',
  'p-accordionpanel-active',
  'p-animateonscroll',
  'p-autocomplete',
  'p-autocomplete-dropdown',
  'p-autocomplete-input',
  'p-autocomplete-input-chip',
  'p-autocomplete-input-multiple',
  'p-autocomplete-option',
  'p-badge',
  'p-button',
  'p-button-contrast',
  'p-button-danger',
  'p-button-help',
  'p-button-icon',
  'p-button-icon-only',
  'p-button-info',
  'p-button-label',
  'p-button-link',
  'p-button-outlined',
  'p-button-plain',
  'p-button-secondary',
  'p-button-sm',
  'p-button-success',
  'p-button-text',
  'p-button-warn',
  'p-buttongroup',
  'p-card',
  'p-card-header',
  'p-card-subtitle',
  'p-card-title',
  'p-carousel-indicator-active',
  'p-carousel-indicator-button',
  'p-carousel-item',
  'p-cascadeselect',
  'p-cascadeselect-label',
  'p-cascadeselect-option',
  'p-cascadeselect-option-content',
  'p-cell-editing',
  'p-checkbox',
  'p-checkbox-box',
  'p-checkbox-checked',
  'p-checkbox-icon',
  'p-checkbox-input',
  'p-checkbox-lg',
  'p-checkbox-sm',
  'p-chip',
  'p-chip-label',
  'p-column-resizer',
  'p-column-resizer-helper',
  'p-column-title',
  'p-component',
  'p-component-overlay',
  'p-confirm-dialog-accept',
  'p-confirm-dialog-reject',
  'p-contextmenu-item-content',
  'p-datatable',
  'p-datatable-column-sorted',
  'p-datatable-column-title',
  'p-datatable-filter-add-rule-button',
  'p-datatable-filter-constraint',
  'p-datatable-filter-constraint-selected',
  'p-datatable-filter-overlay',
  'p-datatable-filter-remove-button',
  'p-datatable-filter-remove-rule-button',
  'p-datatable-filter-rule',
  'p-datatable-frozen-tbody',
  'p-datatable-gridlines',
  'p-datatable-header-cell',
  'p-datatable-mask',
  'p-datatable-row-selected',
  'p-datatable-scrollable-table',
  'p-datatable-sort-badge',
  'p-datatable-sort-icon',
  'p-datatable-striped',
  'p-datatable-table',
  'p-datatable-table-container',
  'p-datatable-tbody',
  'p-datatable-tfoot',
  'p-datatable-thead',
  'p-datepicker',
  'p-datepicker-calendar',
  'p-datepicker-dropdown',
  'p-datepicker-group',
  'p-datepicker-header',
  'p-datepicker-month',
  'p-datepicker-month-view',
  'p-datepicker-next',
  'p-datepicker-next-button',
  'p-datepicker-prev-button',
  'p-datepicker-select-month',
  'p-datepicker-select-year',
  'p-datepicker-title',
  'p-datepicker-today',
  'p-datepicker-year',
  'p-datepicker-year-view',
  'p-dialog',
  'p-dialog-content',
  'p-dialog-header',
  'p-dialog-header-close',
  'p-dialog-header-icon',
  'p-dialog-header-icons',
  'p-dialog-maximized',
  'p-disabled',
  'p-drawer',
  'p-drawer-bottom',
  'p-drawer-enter-bottom',
  'p-drawer-enter-full',
  'p-drawer-enter-left',
  'p-drawer-enter-right',
  'p-drawer-enter-top',
  'p-drawer-full',
  'p-drawer-leave-bottom',
  'p-drawer-leave-full',
  'p-drawer-leave-left',
  'p-drawer-leave-right',
  'p-drawer-leave-top',
  'p-drawer-left',
  'p-drawer-right',
  'p-drawer-top',
  'p-dropdown',
  'p-dropdown-label',
  'p-dynamicdialog',
  'p-dynamicdialog-content',
  'p-editable-column',
  'p-editor',
  'p-editor-toolbar',
  'p-fieldset-toggle-button',
  'p-floatlabel',
  'p-focus',
  'p-focus-visible',
  'p-galleria-thumbnail-item',
  'p-hidden-accessible',
  'p-hidden-focusable',
  'p-highlight',
  'p-icon',
  'p-icon-spin',
  'p-iconfield',
  'p-iftalabel',
  'p-ink',
  'p-inputgroup',
  'p-inputgroupaddon',
  'p-inputmask',
  'p-inputmask-clear-icon',
  'p-inputnumber',
  'p-inputnumber-button',
  'p-inputnumber-button-group',
  'p-inputnumber-horizontal',
  'p-inputnumber-increment-button',
  'p-inputnumber-input',
  'p-inputnumber-stacked',
  'p-inputnumber-vertical',
  'p-inputtext',
  'p-inputtext-fluid',
  'p-inputwrapper',
  'p-invalid',
  'p-listbox',
  'p-listbox-dragging',
  'p-listbox-header',
  'p-listbox-list-container',
  'p-listbox-option',
  'p-megamenu-button',
  'p-megamenu-item-content',
  'p-menu-item-content',
  'p-menu-overlay',
  'p-menubar',
  'p-menubar-button',
  'p-menubar-item-content',
  'p-menubar-item-icon',
  'p-menubar-item-label',
  'p-menubar-item-link',
  'p-menubar-root-list',
  'p-message-leave-active',
  'p-motion',
  'p-multiselect',
  'p-multiselect-label',
  'p-multiselect-option',
  'p-orderlist',
  'p-orderlist-controls',
  'p-orderlist-controls-right',
  'p-overflow-hidden',
  'p-overlay-badge',
  'p-overlay-bottom',
  'p-overlay-bottom-end',
  'p-overlay-bottom-start',
  'p-overlay-content',
  'p-overlay-left',
  'p-overlay-left-end',
  'p-overlay-left-start',
  'p-overlay-mask',
  'p-overlay-modal',
  'p-overlay-right',
  'p-overlay-right-end',
  'p-overlay-right-start',
  'p-overlay-top',
  'p-overlay-top-end',
  'p-overlay-top-start',
  'p-overlaybadge',
  'p-paginator-bottom',
  'p-paginator-top',
  'p-panelmenu-header-active',
  'p-panelmenu-header-content',
  'p-panelmenu-item-content',
  'p-panelmenu-item-link',
  'p-panelmenu-panel',
  'p-panelmenu-root-list',
  'p-panelmenu-submenu',
  'p-password-enter',
  'p-password-fluid-directive',
  'p-password-leave',
  'p-password-overlay',
  'p-picklist',
  'p-picklist-controls',
  'p-picklist-item',
  'p-placeholder',
  'p-radiobutton',
  'p-radiobutton-box',
  'p-radiobutton-checked',
  'p-radiobutton-input',
  'p-rating',
  'p-rating-icon',
  'p-rating-option',
  'p-rating-option-active',
  'p-readonly',
  'p-resizable-column',
  'p-ripple',
  'p-ripple-disabled',
  'p-row-editor-cancel',
  'p-row-editor-init',
  'p-row-editor-save',
  'p-rowgroup-header',
  'p-scroller-loading',
  'p-scrollpanel',
  'p-select',
  'p-select-dropdown',
  'p-select-label',
  'p-select-option',
  'p-select-overlay',
  'p-selectbutton',
  'p-skeleton',
  'p-slider',
  'p-slider-handle',
  'p-sortable-column',
  'p-sortable-column-badge',
  'p-sortable-column-icon',
  'p-splitter',
  'p-splitter-gutter',
  'p-splitter-panel',
  'p-step-header',
  'p-steppanel',
  'p-tab',
  'p-tab-active',
  'p-tablist-nav-button',
  'p-tabs-scrollable',
  'p-tag',
  'p-textarea',
  'p-tieredmenu-item-content',
  'p-tieredmenu-overlay',
  'p-toast',
  'p-toast-summary',
  'p-togglebutton',
  'p-togglebutton-icon-right',
  'p-toggleswitch',
  'p-toggleswitch-checked',
  'p-toggleswitch-handle',
  'p-toggleswitch-input',
  'p-toggleswitch-slider',
  'p-tooltip',
  'p-tooltip-text',
  'p-tree-mask',
  'p-tree-node-content',
  'p-treeselect',
  'p-treeselect-clear-icon',
  'p-treeselect-label',
  'p-treetable',
  'p-treetable-auto-layout',
  'p-treetable-column-sorted',
  'p-treetable-contextmenu-row-selected',
  'p-treetable-flex-scrollable',
  'p-treetable-footer',
  'p-treetable-frozen-view',
  'p-treetable-gridlines',
  'p-treetable-header',
  'p-treetable-header-cell',
  'p-treetable-hoverable',
  'p-treetable-hoverable-rows',
  'p-treetable-lg',
  'p-treetable-loading-icon',
  'p-treetable-mask',
  'p-treetable-paginator-bottom',
  'p-treetable-paginator-top',
  'p-treetable-reorder-indicator-down',
  'p-treetable-reorder-indicator-up',
  'p-treetable-resizable',
  'p-treetable-resizable-fit',
  'p-treetable-row-selected',
  'p-treetable-scrollable-body',
  'p-treetable-scrollable-footer',
  'p-treetable-scrollable-header',
  'p-treetable-scrollable-view',
  'p-treetable-scrollable-wrapper',
  'p-treetable-selectable-row',
  'p-treetable-sm',
  'p-treetable-sort-icon',
  'p-treetable-tbody',
  'p-treetable-tfoot',
  'p-treetable-thead',
  'p-treetable-toggler',
  'p-treetable-unfrozen-view',
  'p-treetable-virtual-scrollable-body',
  'p-treetable-virtual-table',
  'p-treetable-wrapper',
  'p-variant-filled',
  'p-virtualscroller',
  'p-virtualscroller-content',
  'p-virtualscroller-horizontal',
  'p-virtualscroller-inline',
  'p-virtualscroller-loader',
  'p-virtualscroller-loader-mask',
  'p-virtualscroller-loading-icon',
  'p-virtualscroller-spacer',
  'palette-group',
  'palette-header',
  'palette-header-count',
  'palette-header-sticky',
  'palette-header-title',
  'palette-item',
  'palette-title',
  'pb-1',
  'pb-6',
  'pi',
  'pi-angle-down',
  'pi-angle-left',
  'pi-angle-right',
  'pi-arrow-down',
  'pi-asterisk',
  'pi-ban',
  'pi-bars',
  'pi-bell',
  'pi-bolt',
  'pi-chart-line',
  'pi-check',
  'pi-check-circle',
  'pi-check-square',
  'pi-chevron-down',
  'pi-chevron-left',
  'pi-chevron-right',
  'pi-circle',
  'pi-cog',
  'pi-comment',
  'pi-copy',
  'pi-credit-card',
  'pi-ellipsis-v',
  'pi-envelope',
  'pi-exclamation-circle',
  'pi-exclamation-triangle',
  'pi-external-link',
  'pi-home',
  'pi-inbox',
  'pi-info-circle',
  'pi-lightbulb',
  'pi-link',
  'pi-lock',
  'pi-microchip-ai',
  'pi-pencil',
  'pi-plus',
  'pi-question-circle',
  'pi-refresh',
  'pi-search',
  'pi-shield',
  'pi-sign-out',
  'pi-sparkles',
  'pi-spin',
  'pi-spinner',
  'pi-star-fill',
  'pi-times',
  'pi-trash',
  'pi-user',
  'pi-wave-pulse',
  'pl-6',
  'pointer-events-auto',
  'pointer-events-none',
  'pr-0',
  'pr-2',
  'profile-section',
  'provider-chip',
  'pt-0',
  'pt-2',
  'pt-3',
  'pt-4',
  'px-2',
  'px-3',
  'px-4',
  'px-6',
  'py-0',
  'py-0.5',
  'py-1',
  'py-10',
  'py-2',
  'py-3',
  'py-4',
  'py-6',
  'py-8',
  'radius',
  'relative',
  'required',
  'resize-none',
  'result-item',
  'results',
  'results-title',
  'right-0',
  'role',
  'rounded',
  'rounded-full',
  'rounded-lg',
  'rounded-md',
  'rounded-none',
  'rounded-xl',
  'scss',
  'search-btn',
  'search-input',
  'section.sectionIcon',
  'selected',
  'self-start',
  'sentry-block',
  'sentry-ignore',
  'sentry-mask',
  'shadow-lg',
  'shortcut',
  'shrink-0',
  'sidebar',
  'sidebar--collapsed',
  'sidebar__header',
  'sidebar__item',
  'sidebar__item--active',
  'sidebar__item-date',
  'sidebar__item-delete',
  'sidebar__item-select',
  'sidebar__item-title',
  'sidebar__list',
  'sidebar__new-chat',
  'sidebar__status',
  'sidebar__title',
  'sidebar__toggle',
  'skip-link',
  'space-y-1',
  'tabular-nums',
  'tag-chip',
  'text-2xl',
  'text-4xl',
  'text-[inherit]',
  'text-amber-700',
  'text-base',
  'text-center',
  'text-end',
  'text-gray-700',
  'text-green-700',
  'text-inherit',
  'text-left',
  'text-lg',
  'text-primary-800',
  'text-red-600',
  'text-red-700',
  'text-sm',
  'text-surface-0',
  'text-surface-300',
  'text-surface-400',
  'text-surface-500',
  'text-surface-600',
  'text-surface-700',
  'text-surface-800',
  'text-surface-900',
  'text-white',
  'text-xl',
  'text-xs',
  'thinking',
  'thinking-dots',
  'thumb-button',
  'timestamp',
  'top-0',
  'trace',
  'trace-accordion-initial-closed',
  'trace-accordion_wrapper',
  'trace_id',
  'tracking-wide',
  'transition-[grid-template-columns]',
  'transition-all',
  'transition-colors',
  'transition-opacity',
  'transition-shadow',
  'transition-transform',
  'truncate',
  'ts',
  'unselected',
  'uppercase',
  'user',
  'w-12',
  'w-16',
  'w-32',
  'w-5',
  'w-8',
  'w-full',
  'w3',
  'welcome',
  'welcome__avatar',
  'welcome__avatar-img',
  'welcome__heading',
  'welcome__prompt',
  'welcome__prompts',
  'welcome__subtext',
  'whitespace-nowrap',
  'with-border',
  'z-0',
]);
